import { object, string } from 'yup';

import { getMaxLengthErrMsg, getMinLengthErrMsg } from '@constants/validationConstants';
import { MAX_2_LENGTH, MAX_60_LENGTH } from '@constants/validationMessages';

export const assetTypeSchema = (handleCheckName: (name: string) => void, name?: string) => object({
	assetTypeName: string()
		.trim()
		.nullable()
		.min(MAX_2_LENGTH, getMinLengthErrMsg('Asset type name', MAX_2_LENGTH))
		.max(MAX_60_LENGTH, getMaxLengthErrMsg('Asset type name', MAX_60_LENGTH))
		.test('assetTypeName', 'Asset type name must be unique',
			async (value) => {
				if (!value) return false;

				try {
					if (name && name === value) return true;

					await handleCheckName(value);

					return true;
				} catch (err) {
					return false;
				}
			},
		),
});

